<template>
  <v-container class="fill-height">
    <v-card
        class="mx-auto"
        max-width="600"
        width="450"
    >
      <v-card-text>
        <ValidationObserver ref="validationObserver" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(login)">
            <v-col
                cols="12"
            >
              <h1 class="text-center">Логин</h1>
            </v-col>
            <v-col
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="e-mail"
                  rules="required"
              >
                <v-text-field
                    v-model="user.email"
                    :error-messages="errors"
                    label="E-mail"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                  v-slot="{ errors }"
                  name="пароль"
                  rules="required"
              >
                <v-text-field
                    v-model="user.password"
                    :error-messages="errors"
                    label="Пароль"
                    type="password"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          <v-col class="alert">
            <v-alert
                dense
                icon="mdi-alert"
                outlined
                type="error"
                :value="alert"
            >
              {{ errorText }}
            </v-alert>
          </v-col>
            <v-col
                cols="12"
                class="text-center"
            >
              <v-btn
                  :disabled="disabled"
                  color="primary"
                  type="submit"
              >
                Логин
              </v-btn>
            </v-col>
        </form>
        </ValidationObserver>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  name: 'Login',
  data () {
    return {
      alert: false,
      disabled: false,
      errorText: '',
      user: {
        email: '',
        password: '',
      },
    }
  },
  methods: {
    async login() {
      try {
        this.disabled = true
        await this.$store.dispatch('security/signIn', this.user)
        await this.$router.push({ name: 'MainPage' })
      } catch (err) {
        console.log(err)
        if (err.response?.status === 400) {
          this.alert = true
          this.errorText = 'Неверные данные'
        } else {
          this.alert = true
          this.errorText = 'Что-то пошло не так. Попробуйте еще раз.'
        }
        this.disabled = false
      }
    }
  }
}
</script>

<style scoped>

</style>
